import type { I18nKeys } from '@/shared/core/hooks/use-translation/use-translation.ts'
import { useTranslation } from '@/shared/core/hooks/use-translation/use-translation.ts'
import '@/teams/portfolio/components/section/skills-section/visual-showcase/visual-showcase.scss'

interface VisualShowcaseProps {
	altKey: I18nKeys
	imageSrc: string
}

export function VisualShowcase({
	imageSrc,
	altKey,
}: Readonly<VisualShowcaseProps>) {
	const { t } = useTranslation()

	return (
		<div className='visual-showcase' data-testid={'visual-showcase'}>
			<img alt={t(altKey)} className='visual-showcase__image' src={imageSrc} />
		</div>
	)
}
